import Tool, { type ToolArgs } from '../../../tools/Tool';
import { inListOfType } from '../utils';
import ListWrapUtils from '../ListWrapUtils';

// Convert selection to/from a numbered list.
class ToolNumberedList extends Tool {
  static toolName = 'Numbered list';
  static iconClass = 'fa-regular fa-list-ol';

  static action({ editor }: ToolArgs): void {
    if (this.isActive({ editor })) {
      ListWrapUtils.unwrapList(editor);
    } else {
      ListWrapUtils.wrapInList(editor, { type: 'ol_list' });
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    return inListOfType(editor, 'ol_list');
  }

  static isEnabled({ controller }: ToolArgs): boolean {
    const tableSelection = controller?.state.pluginState.tableSelection;
    if (!tableSelection) return true;

    return !tableSelection.multipleCellsSelected;
  }
}

export default ToolNumberedList;
